// Preferred-time codes match the scheduler's PreferredTimeWindow for consistency.
export const PREFERRED_TIME_OPTIONS = [
  { value: 'any', label: 'Anytime' },
  { value: 'morning', label: 'Morning' },
  { value: 'afternoon', label: 'Afternoon' },
  { value: 'evening', label: 'Evening' },
] as const;

// Extensible list — English only for now (product decision).
export const LANGUAGE_OPTIONS = [{ value: 'en', label: 'English' }] as const;

export const PREFERRED_TIME_LABEL: Record<string, string> = Object.fromEntries(
  PREFERRED_TIME_OPTIONS.map((o) => [o.value, o.label]),
);
export const LANGUAGE_LABEL: Record<string, string> = Object.fromEntries(
  LANGUAGE_OPTIONS.map((o) => [o.value, o.label]),
);

const PREFERRED_TIME_VALUES = new Set(PREFERRED_TIME_OPTIONS.map((o) => o.value));

/** Coerce a (possibly legacy free-text) preferred-time value to a known code, else 'any'. */
export function normalizePreferredTime(value: string | null | undefined): string {
  return value &&
    PREFERRED_TIME_VALUES.has(value as (typeof PREFERRED_TIME_OPTIONS)[number]['value'])
    ? value
    : 'any';
}
